"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../svg/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var iconCloseValue = 'icon-navigation-close';
var iconPositionValue = 'right';
var Tag = /*#__PURE__*/function (_React$Component) {
  _inherits(Tag, _React$Component);
  var _super = _createSuper(Tag);
  function Tag() {
    var _this;
    _classCallCheck(this, Tag);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onSvgClick", function (event) {
      if (event.keyCode == "13" || event.keyCode == "32") {
        _this.props.onCloseClick();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderTag", function () {
      return /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: -1,
        id: _this.props.id,
        className: "tl-ui tl-tag-value ".concat(_this.props.className ? _this.props.className : ""),
        onKeyDown: _this.props.onKeyDown
      }, _this.getTagContent());
    });
    return _this;
  }
  _createClass(Tag, [{
    key: "getTagContent",
    value: function getTagContent() {
      var tagContent = '';
      var iConPosition = this.props.iconPosition ? this.props.iconPosition : iconPositionValue;
      var iCon = this.props.icon ? this.props.icon : iconCloseValue;
      var tagLabel = this.props.labelLengthTruncated && this.props.label.length > this.props.labelLengthTruncated ? this.props.label.slice(0, this.props.labelLengthTruncated) + '...' : this.props.label;
      if (!this.props.hideIcon) {
        iConPosition === 'left' ? tagContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getSvgContent(iCon), this.getLabelContent(tagLabel, 'left-icon')) : tagContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getLabelContent(tagLabel, 'right-icon'), this.getSvgContent(iCon));
      } else {
        tagContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getLabelContent(tagLabel, 'no-icon'));
      }
      return tagContent;
    }
  }, {
    key: "getLabelContent",
    value: function getLabelContent(label, classValue) {
      var className = "tl-tag-label " + classValue;
      return label && /*#__PURE__*/_react.default.createElement("div", {
        onClick: this.props.onLabelClick,
        className: className
      }, " ", label);
    }
  }, {
    key: "getSvgContent",
    value: function getSvgContent(iCon) {
      var tagLabel = this.props.labelLengthTruncated && this.props.label.length > this.props.labelLengthTruncated ? this.props.label.slice(0, this.props.labelLengthTruncated) + '...' : this.props.label;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-tag-remove",
        role: 'button',
        "aria-label": 'delete ' + this.props.label,
        onClick: this.props.onCloseClick,
        tabIndex: 0,
        onKeyUp: this.onSvgClick
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: "tl-svg-close-icon",
        name: iCon
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderTag());
    }
  }]);
  return Tag;
}(_react.default.Component);
exports.Tag = Tag;